import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import ToleranceSection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/ToleranceSection';
import BasicsSection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/BasicsSection';
import RelationshipsSection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/RelationshipsSection';
import EvaluationSection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/EvaluationSection';
import RiskAssessmentSection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/RiskAssessmentSection';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';
import DictionarySection from 'src/paginas/gestao-risco/risco/RiscoListView/SearchDrawer/components/sections/DictionarySection';
import SearchBar from 'src/componentes/filtro/search-drawer/SearchBar';

const RiscoSearch = ({ model, configuracao }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const showDictionary = useMemo(
    () => configuracao?.habilitarDicionarioRiscos,
    [configuracao]
  );
  const showTolerance = useMemo(
    () => configuracao?.habilitarAcompanhamentoToleranciaRisco,
    [configuracao]
  );

  return (
    <div>
      <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

      <BasicsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <RelationshipsSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      {showDictionary && (
        <DictionarySection
          model={model}
          resources={resources}
          intl={intl}
          searchQuery={searchQuery}
        />
      )}

      <RiskAssessmentSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      <EvaluationSection
        model={model}
        resources={resources}
        intl={intl}
        configuracao={configuracao}
        searchQuery={searchQuery}
      />

      {showTolerance && (
        <ToleranceSection
          model={model}
          resources={resources}
          intl={intl}
          searchQuery={searchQuery}
          configuracao={configuracao}
        />
      )}

      <CustomFieldsSection
        model={model}
        intl={intl}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default RiscoSearch;
